export enum StandardDonationStateAction {
  ACCEPT = 'accept',
  ARRIVE = 'arrive',
  AUTO_DECLINE = 'auto_decline',
  CANCEL = 'cancel',
  COMPLETE = 'complete',
  DECLINE = 'decline',
  DONOR_CANCEL = 'donor_cancel',
  EN_ROUTE = 'en_route',
}
